import ButtonWrapper from 'app/pages/frames/components/styled-components/Button';
import classNames from 'classnames';

import { IButton } from './interface';
import './styles.scss';

export const Button = ({
  children,
  className,
  disabled,
  isLoading = false,
  onClick,
  type,
  size = 'large',
  fullWidth = true,
}: IButton) => {
  const TYPE_EVAL = type ? 'submit' : 'button';
  return (
    <ButtonWrapper
      className={classNames(className)}
      fullWidth={fullWidth}
      disabled={disabled}
      loading={isLoading}
      onClick={onClick ? () => onClick() : () => null}
      size={size}
      type={TYPE_EVAL}
    >
      {children}
    </ButtonWrapper>
  );
};
